module.exports = __webpack_public_path__ + "static/logosHorizontal-ec0dbff83e89b00d5e5c28719fc9f3a9.png";